import React, { useState, useEffect } from 'react';
import './style/Application.css';

function Applications() {
    const [passportNumber, setPassportNumber] = useState('');
    const [carNumber, setCarNumber] = useState('');
    const [carTechPassport, setCarTechPassport] = useState('');
    const [services, setServices] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [loadingCarData, setLoadingCarData] = useState(false);

    // Загружаем список услуг с сервера при загрузке компонента
    useEffect(() => {
        fetch('/api/services') // API для получения списка услуг
            .then(res => res.json())
            .then(data => setServices(data))
            .catch(() => alert('Ошибка загрузки услуг'));
    }, []);

    // Обработка выбора услуги
    const handleCheckboxChange = (serviceId) => {
        setSelectedServices(prev => {
            if (prev.includes(serviceId)) {
                return prev.filter(id => id !== serviceId);
            } else {
                return [...prev, serviceId];
            }
        });
    };

    // Получить данные об авто (заглушка, обычно запрос к API)
    const handleGetCarData = () => {
        if (!passportNumber) {
            alert('Введите паспортные данные для получения информации об авто');
            return;
        }

        setLoadingCarData(true);

        // Пример запроса к серверу для получения данных по паспорту
        fetch(`/api/users/car-info?passportNumber=${passportNumber}`)
            .then(res => {
                if (!res.ok) throw new Error('Данные не найдены');
                return res.json();
            })
            .then(data => {
                setCarNumber(data.carNumber || '');
                setCarTechPassport(data.carTechPassport || '');
            })
            .catch(err => alert(err.message))
            .finally(() => setLoadingCarData(false));
    };

    // Отправка заявки
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!passportNumber) {
            alert('Пожалуйста, введите паспортные данные');
            return;
        }

        if (selectedServices.length === 0) {
            alert('Выберите хотя бы одну услугу');
            return;
        }

        const applicationData = {
            passportNumber,
            carNumber,
            carTechPassport,
            serviceIds: selectedServices,
        };

        fetch('/api/applications', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(applicationData),
        })
            .then(res => {
                if (!res.ok) throw new Error('Ошибка при отправке заявки');
                alert('Заявка успешно отправлена!');
                // очистка формы
                setPassportNumber('');
                setCarNumber('');
                setCarTechPassport('');
                setSelectedServices([]);
            })
            .catch(err => alert(err.message));
    };

    return (
        <div className="application-container">
            <h2>Продолжение заявки</h2>

            <form onSubmit={handleSubmit} className="application-form1">
                <div className="form-group1">
                    <label htmlFor="passportNumber">Паспортные данные</label>
                    <input
                        id="passportNumber"
                        type="text"
                        value={passportNumber}
                        onChange={e => setPassportNumber(e.target.value)}
                        placeholder="Введите паспортные данные"
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Выбор услуг</label>
                    <div className="services-list">
                        {services.length === 0 && <p>Загрузка услуг...</p>}
                        {services.map(service => (
                            <label key={service.id} className="service-checkbox">
                                <input
                                    type="checkbox"
                                    checked={selectedServices.includes(service.id)}
                                    onChange={() => handleCheckboxChange(service.id)}
                                />
                                {service.name}
                            </label>
                        ))}
                    </div>
                </div>

                <div className="form-group">
                    <button
                        type="button"
                        onClick={handleGetCarData}
                        disabled={loadingCarData}
                        className="btn btn-secondary"
                    >
                        {loadingCarData ? 'Загрузка...' : 'Получить данные об авто'}
                    </button>
                </div>

                <div className="form-group">
                    <label htmlFor="carNumber">Гос. номер авто</label>
                    <input
                        id="carNumber"
                        type="text"
                        value={carNumber}
                        onChange={e => setCarNumber(e.target.value)}
                        placeholder="Гос. номер авто"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="carTechPassport">Техпаспорт авто</label>
                    <input
                        id="carTechPassport"
                        type="text"
                        value={carTechPassport}
                        onChange={e => setCarTechPassport(e.target.value)}
                        placeholder="Техпаспорт авто"
                    />
                </div>

                <div className="form-group">
                    <button type="submit" className="btn btn-primary">
                        Отправить заявку
                    </button>
                </div>
            </form>
        </div>
    );
}

export default Applications;
